import React, { useMemo } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Routes,
  Route,
} from "react-router-dom";
import { Layout } from "@/components/organisms/Layout/index.tsx";
import { ModalWrapper } from "./ModalWrapper";
import { Home } from "@/pages/Home/index";
import { Menu } from "@/pages/Menu/index";
// import { Orders } from "@/pages/Orders";
// import { Promotions } from "@/pages/Promotions";
import { PreorderPage } from "@/pages/PreorderPage";
import { PreorderPageExample } from "@/examples";
import { DataLoader } from "@/components/DataLoader";
import { CartSyncProvider } from "@/context/CartSyncContext";
import DebugImageTest from "@/debug-image-test";

// Main App Component with Modal Wrapper
const MainApp: React.FC = () => {
  return (
    <DataLoader>
      <CartSyncProvider>
        <ModalWrapper>
          <Layout>
            <Routes>
              <Route index element={<Home />} />
              <Route path="menu/*" element={<Menu />} />
              {/* <Route path="promotions" element={<Promotions />} /> */}
              {/* <Route path="orders" element={<Orders />} /> */}
            </Routes>
          </Layout>
        </ModalWrapper>
      </CartSyncProvider>
    </DataLoader>
  );
};

export const AppRouter: React.FC = () => {
  const router = useMemo(() => {
    const { pathname } = window.location;
    if (pathname.startsWith("/m/preorder")) {
      return createBrowserRouter(
        [
          {
            path: "/*",
            element: (
              <DataLoader>
                <CartSyncProvider>
                  <ModalWrapper>
                    <PreorderPage />
                  </ModalWrapper>
                </CartSyncProvider>
              </DataLoader>
            ),
          },
        ],
        {
          basename: "/m/preorder",
        }
      );
    }
    return createBrowserRouter([
      {
        path: "/examples",
        element: (
          <DataLoader>
            <PreorderPageExample />
          </DataLoader>
        ),
      },
      {
        path: "/debug-image",
        element: <DebugImageTest />,
      },
      {
        path: "/*",
        element: <MainApp />,
      },
    ]);
  }, []);

  return <RouterProvider router={router} />;
};
